import React from 'react';
import PropTypes from 'prop-types';
import { HideOnMobile } from '../../atoms';
import { PromoPill } from '../../molecules';
import { CHECKOUT_STEPS } from '../CheckoutHeader/constants';
import { CheckoutHeader } from '../CheckoutHeader';

export const Header = ({ step }) => {
  const rightHeaderSegment = (
    <HideOnMobile>
      <PromoPill />
    </HideOnMobile>
  );

  return (
    <CheckoutHeader
      currentStep={CHECKOUT_STEPS[step]}
      rightSegment={rightHeaderSegment}
      steps={CHECKOUT_STEPS}
    />
  );
};

Header.propTypes = {
  step: PropTypes.number.isRequired,
};
